import React from 'react'
import { Box } from '@chakra-ui/react'
import  "./css/Navbar.css"

const Navbar = ({setelem}) => {
  return (
    <div className='navbarmain'>
      <div className='navbarleft'>
         <img className='logo' src="./images/br.png" alt=''/>
         <p className='name'>Bharat Rozodkar</p>
      </div>
         
      <div className='navbarright'> 
         <a href='#about' className='navbartabs'>About Me</a>   
         <a href='#skills' className='navbartabs' >Skills</a>
         <a href='#projects' className='navbartabs' >Projects</a>
         <a href='#experience' className='navbartabs'> Experience</a>
            <a href='#footer' className='navbartabs' >Contacts</a>
      </div>
    </div>
  )
}

export default Navbar
